<template>
    <div class="mm_body">
        <mmheader :mm-site-url="mm_site_url"></mmheader>
        <section class="pad-60">
	        <div class="container"  style="margin-top: 72px;">
                <div class="row max-680">
                    <flash-message autoHide variant="success"></flash-message>
                    <flash-message autoHide variant="danger"></flash-message>
                    <div v-show="login_errors" class="validate-warning-msg-login">{{ login_errors }}</div>
                    <b-alert
                      :show="dismissAuthCountDown"
                      dismissible
                      variant="success"
                      @dismissed="dismissAuthCountDown=0"
                      @dismiss-count-down="countDownAuthChanged"
                      >
                      {{ success_auth_message }}
                    </b-alert>
                    <b-alert
                      :show="dismissCountWarningDown"
                      dismissible
                      variant="danger"
                      @dismissed="dismissCountWarningDown=0"
                      @dismiss-count-down="countDownWarningChanged"
                      >
                      {{ warning_message }}
                    </b-alert>
                    <h1 class="inner-page mm-login-text text-center">Welcome back, {{ this.$store.state.mfa_first_name }}!</h1>
                    <hr class="d-none">
                    <div class="mm-pad-30">
                        <form class="form-signin" @submit.prevent="onSubmit" autocomplete="off">
                            <div class="form-group" style="font-size: 13px; padding-bottom: 5px; text-align: center;">
                                Please enter the 6 digit code sent to your email.
                            </div>
                            <div class="form-group">

                                <SimpleOtpInput 
                                  v-model="code"
                                  :inputProps="{
                                    type: 'number',
                                    min: 0,
                                  }" 
                                  @change="handleChange"/>

                            </div>
                            <div class="text-center pad-20 margin-bottom-20- pb-2">
                                <button type="submit" class="btn btn-lg btn-blue get-started-btn" :disabled="disable_verify_btn" :class="disable_verify_btn ? 'btn-blue-disabled' : 'btn-blue'" @click="verifyCode()">Log In</button>
                            </div>
            <div class="col-7 text-center" style="margin: 0 auto; color: #00ACEE; cursor: pointer; font-size: 14px; padding-top: 20px;" @click="resendCode()">
                Did not receive a code?
            </div>

                        </form>
                    </div>
                </div>
            </div>
        </section>
        <mmfooter :mm-site-url="mm_site_url"></mmfooter>
    </div>
</template>
<style scoped>
@import 'https://fonts.googleapis.com/css2?family=Roboto+Condensed:wght@700&display=swap';
.get-started-btn, .text-bebas-btn, .text_bebas, .mm_text_bebas h2, h3 {
    /* font-family: 'Roboto Condensed', sans-serif; */
}
.text_bebas {
    font-size: 19px !important;
}
.get-started-btn {
    font-family: 'bebas-neue-pro', sans-serif;
}
.mm-login-text {
    color: #002F42 !important;
    font-family: 'bebas-neue-pro', sans-serif;
}
.mm_body {
    font-size: 20px !important;
    max-width: 2400px;
    margin: auto;
}
.pad-60 {padding: 60px 0px;}
.pad-20 {padding: 20px;}
.max-680 {max-width: 560px; margin: auto;}
.margin-bottom-60 {margin-bottom: 60px;}
.margin-bottom-30 {margin-bottom: 30px;}
.margin-20 {margin: 20px 0px;}
.row {
    display: block;
}
/* Form input css start */
.form-group {
    margin-bottom: 8px;    
}
.form-control {height: 46px;}
.form-control {font-size: 18px; color: #000; /* background: #F5F5F5; */ }
.form-control:focus {
    border-color: #d3d3d3;
    /* box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); */
}
.validate-warning-msg {
    text-align: left;
    font-size: 16px;
}
/* Form input css stop */
/* button css start */
.btn-lg {padding: 14px 50px;}
.btn-blue {background-color: #00ACEE !important; color: #fff;}
.btn {border-radius: 18px; border: none; font-size: 22px !important; font-weight: bold; font-style:  normal;}
.btn:hover, .btn:focus {color: #fff !important; text-decoration: underline; outline: 0 !important;}
/* button css stop */
/* anchor css start */
a { color: #00ACEE; cursor: pointer; font-size: 20px; }
a:focus, a:hover { color: #00ACEE; text-decoration: underline;}
a:hover {opacity: 0.9;}
/* anchor css stop */
/* heading css start */
h1 {
    color: #4B4B4B !important;
}
.h1, h1 {
    font-size: 36px !important;
}
.h1, .h2, .h3, h1, h2, h3 {
    margin-top: 20px;
    margin-bottom: 10px;
}
.h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6 {
    font-family: inherit;
    font-weight: 500;
    line-height: 1.1;
    color: inherit;
}
/* heading css stop */
hr {
    border-top: 1px solid #e3e3e3;
    margin-top: 20px;
    margin-bottom: 20px;
}
/* media query css start */
@media (max-width: 991px) {
    .pad-60 {padding: 60px 20px;}
}
@media (min-width: 1200px){
    .container {
        width: 1170px !important;
    }
}
@media (max-width: 320px) {
    .btn-lg { padding: 0.5rem 1rem; }
    .logo-main img { width: 160px; margin-top: -8px; }
}
/* media query css stop */
.mm-pad-30 {
    padding: 30px;
}
.get-started-btn {
    padding: 6px 72px;
    border-radius: 10px;
    font-size: 18px !important;
}

/* verify code css */
/deep/ .otp-single-input {
  width: 64px;
  height: 64px;
  font-size: 32px;
  border-radius: 7px;
  border: 1px solid #ced4da;
  font-weight: bold;
}
/deep/ .single-input-container {
  margin: 0px 6px;
}

/deep/ input.otp-single-input[type="number"] {
  -moz-appearance: textfield;
}

/deep/ input.otp-single-input[type="number"]::-webkit-outer-spin-button,
/deep/ input.otp-single-input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/deep/ input.otp-single-input[type="number"] {
  appearance: textfield;
}
</style>
<script>
import SimpleOtpInput from "vue-simple-otp-input";
import 'vue-simple-otp-input/dist/vue-simple-otp-input.css';
import axios from 'axios';
import Vue from 'vue/dist/vue.esm';
import VeeValidate from 'vee-validate';
import router from '../router/index.js';
import {login} from 'vuex';
import store from '../store/store.js';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

import mmheader from './mm_header';
import mmfooter from './mm_footer';
import MmForgotPassword from './mm_forgotpassword';
import MmSuccessModal from './mm_success_modal';

export default {
    data() {
        return {
            mm_site_url: process.env.MM_SITE_URL,
            signin_value: 'Log In',
            email: '',
            password: '',
            login_errors: '',
            isModalVisible: false,
            isSuccessModalVisible: false,
            roles: [],
            admin_role_flag: '',
            manager_role_flag: '',
            mentor_role_flag: '',
            mentee_role_flag: '',
            apprentice_role_flag: '',
            instructor_role_flag: '',
            student_role_flag: '',
            enterprise_admin_role_flag: '',
            researcher_role_flag: '',
            csr_role_flag: '',
            userAccounts: {
                isUserLinkedMultipleLocations: false,
                locations: [],
                current: {},
            },
            locationsCount: 0,
              dismissCountWarningDown: 0,
              warning_message: '',
              success_auth_message: '',
              dismissAuthCountDown: 0,
              code: '',
              disable_verify_btn: true,
        }
    },
    components: {
        SimpleOtpInput,
        mmheader,
        mmfooter,
        MmForgotPassword,
        MmSuccessModal
    },
    methods: {
        handleChange(v) {
          if(v.trim().length == 6) {
            this.disable_verify_btn = false;
          } else {
            this.disable_verify_btn = true;
          }
        },
        countDownWarningChanged(dismissCountWarningDown) {
          this.dismissCountWarningDown = dismissCountWarningDown
        },
        countDownAuthChanged(dismissAuthCountDown) {
          this.dismissAuthCountDown = dismissAuthCountDown;
        },
        resendCode() {
            axios('/custom/generate-myprofile-auth-code',
            {
                method: 'GET', 
                params: { 
                  "email": this.$store.state.mfa_email,
                }
            })
            .then(response => {                
                this.success_auth_message = 'Code resend successfully.';
                this.dismissAuthCountDown = 5;

            })
            .catch(error => {

            });


        },
        verifyCode() {
          this.signin_value = 'Please Wait ...';
          if(this.code == '') {
            alert("Please enter the verification code");
            this.signin_value = 'Log In';
            return false;
          }
          else if(this.code.length != 6) {
            alert("Verification code should be 6 digit");
            this.code = '';
            this.signin_value = 'Log In';
            return false;
          }
          else {
            this.disable_verify_btn = true;
            axios('/custom/verify-myprofile-auth-code',
            {
                method: 'POST',
                data: {
                  code: this.code,
                  email: this.$store.state.mfa_email,
                }
            })
            .then(response => {  
              this.$store.dispatch('mfa_success_data', this.$store.state.mfa_data );
              
                if(this.$store.state.sign_count == 1) {
                  this.$store.dispatch('introduction_template_display', 1);
                }
                this.userRedirection();

            })
            .catch(error => {
              this.warning_message = 'Invalid verification code.';
              this.dismissCountWarningDown = 5;
              this.code = '';
              this.signin_value = 'Log In';
            });
          }

        },
        navigate(path) {
            router.push(path);
        },
        isInArray(value, array) {
            return array.indexOf(value) > -1;
        },
        userRedirection: function() {
            this.roles = this.$store.state.roles;
            if(this.roles) {
                this.admin_role_flag = this.isInArray('ROLE_MASTER_ADMIN', this.roles);
                this.researcher_role_flag = this.isInArray('ROLE_RESEARCHER', this.roles);
                this.csr_role_flag = this.isInArray('ROLE_CSR', this.roles);
                this.enterprise_admin_role_flag = this.isInArray('ROLE_ENTERPRISE_ADMIN', this.roles);
                if (this.admin_role_flag) {
                    this.navigate("/admin-dashboard");
                }
                else if (this.researcher_role_flag == true) {
                    this.navigate("/researcher-dashboard");
                } 
                else if (this.csr_role_flag == true) {
                    this.navigate("/csr-dashboard");
                } 
                else if(this.enterprise_admin_role_flag === true) {
                    this.getEnterpriseAdminInfo();
                } else {
                    this.getUserLinkedLocations();
                }
            }
        },
        openSuccessModal() {
            this.isSuccessModalVisible = true;
        },
        getUserLinkedLocations() {
            axios.get('/user/linked-locations', {
            })
            .then(response =>  {
                this.locations = response.data;
                this.locationsCount = this.locations.length;
                this.userAccounts.isUserLinkedMultipleLocations = false;
                this.userAccounts.locations = this.locations;
                if (this.locationsCount > 1) {
                    this.userAccounts.isUserLinkedMultipleLocations = true;
                    this.$store.dispatch('set_user_locations', this.userAccounts);
                    this.navigate('/user/select-location');
                } else {
                    this.$store.dispatch('set_user_accountid', this.userAccounts.locations[0].accId);
                    this.$store.dispatch('set_user_locations', this.userAccounts);
                    this.roleBasedRedirection();
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
        roleBasedRedirection() {
            if (this.roles) {
                this.manager_role_flag = this.isInArray('ROLE_ADMIN', this.roles);
                this.mentor_role_flag = this.isInArray('ROLE_MENTOR', this.roles);
                this.mentee_role_flag = this.isInArray('ROLE_MENTEE', this.roles);
                this.apprentice_role_flag = this.isInArray('ROLE_APPRENTICE', this.roles);
                this.instructor_role_flag = this.isInArray('ROLE_INSTRUCTOR', this.roles);
                this.student_role_flag = this.isInArray('ROLE_STUDENT', this.roles);
                if(this.$store.state.switch_flag) {
                    var url = this.userRedirect(this.$store.state.switch_flag);
                    this.navigate(url);
                }
                else if(this.manager_role_flag === true) {
                    if(this.$store.state.school_flag == 1) {
                        this.navigate("/school-admin-dashboard");
                    }
                    else {
                        this.navigate("/company-admin-dashboard");
                    }
                }
                else if(this.mentor_role_flag === true) {
                    // this.navigate("/mentees-tasks-list");
                    this.navigate("/mentor-dashboard");
                }
                else if(this.mentee_role_flag === true) {
                    this.navigate("/mentee-dashboard");
                }
                else if(this.apprentice_role_flag === true) {
                    this.navigate("/apprentice-dashboard");
                }
                else if(this.instructor_role_flag === true) {
                    this.navigate("/students-tasks-list");
                }
                else if(this.student_role_flag === true) {
                    this.navigate("/student-dashboard");
                }
            }
        },
        getEnterpriseAdminInfo() {
            axios('/enterprise-admin-info-accountid',
            {
                method: 'GET',
            })
            .then(resp => {
                this.$store.dispatch('set_enterprise_type', resp.data.account.enterprise_type);
                this.navigate("/enterprise-admin-dashboard");
            })
            .catch(() => {
            });
        }
    },
    created: function() {
        document.body.className = 'login-page';
        this.$store.dispatch('clear_user_locations');
    }
}
</script>


// WEBPACK FOOTER //
// src/components/mm_mfa_verify.vue